export const SHOP_NOTIFICATION_TYPE_FILTER_OPTIONS = [
  { value: "all", label: "ທຸກປະເພດ" },
  { value: "FITMENT_COMPLETE", label: "Fitment ຄົບ" },
  { value: "LISTING_HIDDEN", label: "Listing ຖືກຊ້ອນ" },
  { value: "MARKETPLACE_ORDER", label: "ຄຳສັ່ງ marketplace" },
  { value: "DISPUTE_OPENED", label: "Dispute" },
  { value: "PAYOUT_SETTLED", label: "Settlement" },
] as const;

export const SHOP_NOTIFICATION_TYPE_LABELS: Record<string, string> = {
  FITMENT_COMPLETE: "Fitment ຄົບ",
  LISTING_HIDDEN: "Listing ຖືກຊ້ອນ",
  MARKETPLACE_ORDER: "ຄຳສັ່ງ marketplace",
  DISPUTE_OPENED: "Dispute",
  PAYOUT_SETTLED: "Settlement",
};

export function shopNotificationTypeLabel(type: string): string {
  return SHOP_NOTIFICATION_TYPE_LABELS[type] ?? type;
}
